import React from 'react';
import { withRouter } from 'react-router';
import styles from './styles';
import { useHistory } from "react-router-dom";
const SideMenu = ({ open, toggle }) => {
    const history = useHistory();
    return (
        <>  
            <styles.BackPanel open={open} onClick={toggle}/>
            <styles.ContainerPanel open={open}>
                <styles.ContainerMenu >
                    <styles.MenuOption onClick={() => {toggle(); history.push('/shop');}}>SHOP</styles.MenuOption>
                    <styles.MenuOption onClick={() => {toggle(); history.push('/shop/cart');}}>CART</styles.MenuOption>
                    <styles.MenuOption onClick={() => { window.open("https://calendly.com/luisenriquecgongora") }}>CONSULTATION</styles.MenuOption>
                    <styles.MenuOption onClick={() => {toggle(); history.push('/landing');}}>HOMEPAGE</styles.MenuOption>
                    {/* <styles.MenuOption onClick={() => {toggle(); history.push('shop/purchases');}}>PURCHASES</styles.MenuOption> */}
                </styles.ContainerMenu>
            </styles.ContainerPanel>
        </>

    );
};

export default withRouter(SideMenu);
